{
  "action": {
    "logout": "Logout",
    "delete": "Delete",
    "archive": "Archive",
    "reset": "Reset",
    "edit": "Edit",
    "save": "Save",
    "browse_files": "Browse file",
    "pay_now": "Pay now",
    "pay_feasibility_fee": "Pay feasibility study invoice",
    "pay_full_work_write_up": "Pay inspection & write-up invoice",
    "download": "Download",
    "open": "Open",
    "scroll_to_top": "Scroll to top",
    "scroll_to_bottom": "Scroll to bottom",
    "cancel": "Cancel",
    "submit": "Submit",
    "continue": "Continue",
    "request_correction": "Request correction",
    "download_invoice": "Download invoice",
    "accept": "Accept",
    "reject": "Reject",
    "markAllAsRead": "Mark all as read",
    "deleteAll": "Delete all",
    "deleteNotification": "Delete notification",
    "previous": "Previous",
    "next": "Next",
    "next_step": "Next step",
    "show_less": "Show less",
    "show_more": "Show more",
    "complete": "Complete",
    "suspend": "Suspend",
    "request_costs": "Request costs",
    "submit_costs": "Submit costs",
    "approve_costs": "Approve costs",
    "revertToDraft": "Revert to draft",
    "approve": "Approve",
    "sign": "Sign",
    "sign_in": "Sign in",
    "provide_costs": "Provide costs",
    "done": "Done",
    "print": "Print",
    "convert": "Convert",
    "add_another_item": "Add another item",
    "remove": "Remove",
    "removeItem": "Remove item",
    "backToForm": "Back to form",
    "changePassword": "Change password",
    "back": "Back",
    "assignCompany": "Assign company",
    "addCompany": "Add company",
    "editCompany": "Edit company",
    "deleteCompany": "delete company",
    "addProperty": "Add property",
    "editProperty": "Edit property",
    "deleteProperty": "Delete property",
    "leaveProject": "Leave project",
    "expand": "Expand",
    "collapse": "Collapse",
    "viewDocument": "View document",
    "add": "Add",
    "archiveProject": "Archive project",
    "addMeeting": "Add meeting",
    "addTenant": "Add tenant",
    "addFile": "Add file",
    "addMember": "Add member",
    "addProject": "Add project",
    "addAdmin": "Add admin",
    "addLender": "Add lender",
    "addServiceArea": "Add service area",
    "inviteAdmin": "Invite admin",
    "inviteClient": "Invite client",
    "inviteContractor": "Invite contractor",
    "inviteProjectManager": "Invite project manager",
    "inviteLoanProcessor": "Invite loan processor",
    "inviteInspector": "Invite inspector",
    "inviteLoanOfficer": "Invite loan officer",
    "resendInvitation": "Resend invitation",
    "withdrawInvitation": "Withdraw invitation",
    "rejectInvitation": "Reject invitation",
    "suspendUser": "Suspend user",
    "editMeeting": "Edit meeting",
    "editProfile": "Edit profile",
    "editAddress": "Edit address",
    "editTenant": "Edit tenant",
    "createProject": "Create project",
    "createManualStep": "Create manual step",
    "newProject": "New project",
    "deleteTenant": "Delete tenant",
    "deleteFile": "Delete file",
    "backToLogin": "Back to login",
    "completeRegistration": "Complete registration",
    "login": "Login",
    "resetPassword": "Reset password"
  },
  "label": {
    "super_admin": "Super admin",
    "user": "User",
    "account": "Account",
    "project": "Project",
    "projects": "Projects",
    "property": "Property",
    "properties": "Properties",
    "partners": "Partners",
    "contacts": "Contacts",
    "calendar": "Calendar",
    "settings": "Settings",
    "switchTenant": "Switch tenant",
    "legal": "Legal",
    "notifications": "Notifications",
    "unread": "Unread",
    "yesterday": "Yesterday",
    "contractor": "Contractor",
    "contractors": "Contractors",
    "loan_officer": "Loan officer",
    "loan_officers": "Loan officers",
    "loan_processor": "Loan processor",
    "loan_processors": "Loan processors",
    "project_manager": "Project manager",
    "project_managers": "Project managers",
    "admin": "Admin",
    "admins": "Admins",
    "inspector": "Inspector",
    "inspectors": "Inspectors",
    "client": "Client",
    "clients": "Clients",
    "lender": "Lender",
    "lenders": "Lenders",
    "company": "Company",
    "contracting_company": "Contracting company",
    "contracting_companies": "Contracting companies",
    "lending_companies": "Lending companies",
    "status": "Status",
    "projectStage": "Project stage",
    "full_name": "Full name",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "phone_number": "Phone number",
    "address": "Address",
    "address_line_1": "Address line 1",
    "address_line_2": "Address line 2",
    "city": "City",
    "state": "State",
    "country": "Country",
    "postal_code": "Postal code",
    "profile": "Profile",
    "contact_details": "Contact details",
    "service_area": "Service area",
    "projects_completed": "Projects completed",
    "inspections_completed": "Inspections completed",
    "actions": "Actions",
    "invitation": "Invitation",
    "filters": "Filters",
    "years_of_experience": "Years of experience",
    "experience": "Experience",
    "hud": "HUD",
    "hud_details": "HUD details",
    "hud_id_number": "HUD ID number",
    "issuance_date": "Issuance date",
    "expiry_date": "Expiry date",
    "hud_front_image": "HUD front image",
    "hud_back_image": "HUD back image",
    "license": "License",
    "license_details": "License details",
    "drivers_license": "Driver's license",
    "license_number": "License number",
    "license_front_image": "License front image",
    "license_back_image": "License back image",
    "tax_information": "Tax information",
    "business_name": "Name",
    "tin": "TIN",
    "ssn_ein": "SSN/EIN",
    "tin_ein": "TIN/EIN",
    "entity_type": "Entity type",
    "individual": "Individual",
    "corporate": "Corporate",
    "llc": "LLC",
    "w9": {
      "upload": "Upload W-9 form",
      "form": "W-9 form",
      "description": "If you've already filled out a W-9 form, upload the file below.",
      "banner": "Form W-9 collects a U.S. taxpayer's TIN and certifies their tax status for reporting.",
      "validatedTitle": "W-9 verified",
      "validatedText": "Please confirm that the information below is correct",
      "invalid": "We couldn't extract required data from this W-9. Try uploading a clearer or correct version."
    },
    "service_areas": "Service areas",
    "add_service_area": "Add service area",
    "selected_service_areas": "Selected service areas",
    "remove": "Remove",
    "bank": "Bank",
    "team": "Team",
    "createdOn": "Created on",
    "created_this_week": "Created this week",
    "created_this_month": "Created this month",
    "all_time": "All time",
    "month": "Month",
    "week": "Week",
    "period": "Period",
    "active": "Active",
    "showActiveProjects": "Show only active projects",
    "property_image": "Property image",
    "overview": "Overview",
    "participants": "Participants",
    "documents": "Documents",
    "payments": "Payments",
    "scheduling": "Scheduling",
    "activity_logs": "Activity logs",
    "discussions": "Discussions",
    "project_details": "Project details",
    "general_details": "General details",
    "member": "Member",
    "members": "Members",
    "project_name": "Project name",
    "project_type": "Project type",
    "loan_id": "Loan identifier",
    "fha_case_number": "FHA case number",
    "pre_approved_loan_amount": "Pre-approved loan amount",
    "loan_application_date": "Application date",
    "constructionCompletionDeadline": "Construction completion deadline",
    "dwelling_units": "Dwelling units",
    "feasibility_study": "Feasibility study",
    "feasibility_report": "Feasibility report",
    "full_work_writeup": "Full work write-up",
    "material_draw": "Material draw",
    "full_report": "Full report",
    "client_invoice": "Client invoice",
    "picture": "Picture",
    "inspection_timeline": "Inspection timeline",
    "property_address": "Property address",
    "inspection_fee": "Inspection fee",
    "property_inspection_invoice": "Property inspection invoice",
    "financial_details": "Financial details",
    "property_details": "Property details",
    "inspection_property_details": "Inspection / property details",
    "invoice": "Invoice",
    "invoices": "Invoices",
    "invoice_id": "Invoice ID",
    "description": "Description",
    "amount": "Amount",
    "paid": "Paid",
    "pending": "Pending",
    "file": "File",
    "files": "Files",
    "form": "Form",
    "forms": "Forms",
    "reports": "Reports",
    "property_access": "Property access",
    "inspection_estimate_date": "Inspection estimate date",
    "size": "Size",
    "type": "Type",
    "updated_by": "Updated by",
    "last_updated": "Last updated",
    "photo": "Photo",
    "comment": "Comment",
    "report": "Report",
    "document": "Document",
    "image": "Image",
    "meeting": "Meeting",
    "title": "Title",
    "inspection": "Inspection",
    "review": "Review",
    "planning": "Planning",
    "client_discussion": "Client discussion",
    "other": "Other",
    "date": "Date",
    "time": "Time",
    "optional": "Optional",
    "start_time": "Start time",
    "end_time": "End time",
    "location": "Location",
    "logs": "Logs",
    "project_created": "Project created",
    "document_uploaded": "Document uploaded",
    "project_status_changed": "Project status changed",
    "inspection_accepted": "Inspection accepted",
    "user_accepted": "User accepted",
    "user_added": "User added",
    "today": "Today",
    "day": "Day",
    "upcoming_meetings": "Upcoming meetings",
    "role": "Role",
    "roles": "Roles",
    "username": "Username",
    "onboarding": "Onboarding",
    "personal_information": "Personal information",
    "expertise": "Expertise",
    "confirm_company": "Is this the company you work for?",
    "yes": "Yes",
    "no": "No",
    "contact_us_at": "Contact us at {{email}}",
    "not_my_company": "This is not my company",
    "your_request_submitted": "Your request has been submitted.",
    "no_company_associated_with_account": "There is no company associated with your account.",
    "profile_picture": "Profile picture",
    "minimum_property_standards": "Minimum property standards",
    "specification_of_repairs": "Specification of repairs",
    "work_order": "Work order",
    "renovation_consultant_agreement": "Renovation consultant agreement",
    "messages": "Messages",
    "tenants": "Tenants",
    "tenant": "Tenant",
    "website": "Website",
    "expired": "Expired",
    "invited": "Invited",
    "project_invite_message": "Accept invitation to continue with this project",
    "tenant_name": "Tenant name",
    "tenant_address": "Tenant address",
    "inspector_phone": "Inspector phone",
    "inspection_date": "Inspection date",
    "inspection_address": "Inspection address",
    "point_of_contact": "Point of contact",
    "lending_company": "Lending company",
    "loan_officer_phone": "Loan officer phone",
    "contractor_phone": "Contractor phone",
    "client_phone": "Client phone",
    "client_address": "Client address",
    "note": "Note",
    "not_provided": "Not provided",
    "requested": "Requested",
    "checklist": "Checklist",
    "inspection_conditions": "Inspection conditions",
    "weather_conditions_label": "Weather conditions",
    "weather_conditions": {
      "sunny": "Sunny",
      "cloudy": "Cloudy",
      "rain": "Rain",
      "heavy_rain": "Heavy rain",
      "snow": "Snow",
      "sleet": "Sleet",
      "hail": "Hail",
      "fog": "Fog",
      "windy": "Windy",
      "stormy": "Stormy",
      "frost": "Frost"
    },
    "temperature": "Temperature",
    "utilities_at_inspection": "Utilities at inspection",
    "utilities": "Utilities",
    "electric": "Electric",
    "gas": "Gas",
    "water": "Water",
    "heating": "Heating",
    "sewage": "Sewage",
    "solar": "Solar",
    "other_fuels": "Other fuels",
    "gasDetails": "Gas details",
    "gasType": "Gas type",
    "naturalGas": "Natural gas",
    "propane": "Propane",
    "gasLevel": "Gas level/location",
    "aboveGround": "Above ground",
    "belowGround": "Below ground",
    "tankType": {
      "label": "Tank type",
      "propane": "Propane",
      "heatingOil": "Heating oil",
      "diesel": "Diesel"
    },
    "gas_ownership_label": "Gas ownership",
    "gas_ownership": {
      "owner_supplied": "Owner supplied",
      "tenant_supplied": "Tenant supplied",
      "included_in_rent": "Included in rent",
      "utility_company_owned": "Utility company owned",
      "leased_tank": "Leased tank",
      "master_meter": "Master meter/shared"
    },
    "public_gas_available": "Public gas available",
    "waterDetails": "Water details",
    "sewageDetails": "Sewage details",
    "source": "Source",
    "comments": "Comments",
    "owner_occupied": "Owner occupied",
    "number_of_units": "# of units",
    "units_at_completion": "Units at completion",
    "number_of_stories": "# of stories",
    "number_of_dwellings": "# of dwellings",
    "age_of_dwelling": "Age of dwelling",
    "lot_size": "Lot size",
    "acres": "Acres",
    "property_type": "Property type",
    "residential": "Residential",
    "commercial": "Commercial",
    "questionary": "Questionary",
    "questionaryStep": {
      "generalPropertyInfo": "General property info",
      "utilities": "Utilities",
      "waterAndSewage": "Water and sewage",
      "accessAndEnvironment": "Access and environment",
      "propertyCondition": "Property condition",
      "habitabilityAndStructure": "Habitability and structural spaces"
    },
    "mps_q1": "Does this property appear to be singularly marketable?",
    "mps_q2": "If property is constructed on a property line, is it separated from the adjoining building by a wall extending the full height of the building from foundation to roof?",
    "mps_q3": "Does adequate space between buildings exist to permit maintenance of exterior walls?",
    "mps_q4": "Can living units be maintained without trespassing onto adjacent property?",
    "mps_q5": "Are utilities independent in each living unit?",
    "mps_q6": "Do units have a separate utility shut off?",
    "mps_q7": "Are there shared baths or kitchens between units?",
    "mps_q8": "Each living unit has",
    "mps_q8_1": "Continuous, safe, potable water",
    "mps_q8_2": "Safe sanitary sewage disposal",
    "mps_q8_3": "Adequate, healthful, comfortable & heated living environment",
    "mps_q8_4": "Domestic hot water",
    "mps_q8_5": "Electricity in each unit",
    "mps_q9": "Does property have individual water supply & sewage disposal systems?",
    "mps_q9_1": "Does water meet health authority requirements?",
    "mps_q9_2": "Safe, sanitary sewage disposal as required by public health authority?",
    "mps_q9_3": "Is public water and/or sewage connection feasible?",
    "mps_q10": "Units will be used for?",
    "mps_q10_1": "Is non-residential use subordinate to residential use?",
    "mps_q10_2": "Is non-residential usage greater than 25% (1 to 4 story dwelling)?",
    "mps_q10_3": "If dwellings are detached, NOT greater than 49% (2 story dwelling)?",
    "mps_q11": "Regarding property access",
    "mps_q11_1": "Is access safe & adequate for pedestrians or vehicles from public or private street?",
    "mps_q11_2": "Do streets have an all weather surface?",
    "mps_q11_3": "Are private streets protected by permanent easement & maintained by private or public agreements?",
    "mps_q11_4": "Are living units freely accessible? (Independent accessibility)",
    "mps_q11_5": "Is the rear yard freely accessible? (Independent accessibility)",
    "mps_q12": "Does the property have apparent defective conditions requiring remedy?",
    "mps_q12_1": "Defective construction",
    "mps_q12_2": "Poor construction workmanship",
    "mps_q12_3": "Evidence of continual settling",
    "mps_q12_4": "Excessive dampness",
    "mps_q12_5": "Leakage",
    "mps_q12_6": "Decay",
    "mps_q12_7": "Termites",
    "mps_q12_8": "Other conditions",
    "mps_q13": "Does each living unit have suitable living, sleeping, cooking, dining, accommodations & sanitary facilities?",
    "mps_q14": "Does the property have apparent defective conditions requiring remedy?",
    "mps_q14_1": "HVAC",
    "mps_q14_2": "Plumbing",
    "mps_q14_3": "Electrical",
    "mps_q14_4": "Smoke Detectors",
    "mps_q15": "Attic is",
    "mps_q15_1": "Accessible",
    "mps_q15_2": "Naturally Ventilated",
    "mps_q15_3": "Adequately Insulated",
    "mps_q16": "Crawl Space",
    "mps_q16_1": "Adequate access to crawl space",
    "mps_q16_2": "Is ventilated",
    "mps_q16_3": "Access to maintain plumbing",
    "mps_q16_4": "Crawl space clear of debris and/or defects (no vapor barrier)",
    "mps_q17": "Crawl space clear of debris and/or defects (no vapor barrier)",
    "mps_q18": "Is property free of hazards?",
    "mps_q18_1": "Asbestos",
    "mps_q18_2": "EPA requirements",
    "mps_q18_3": "Lead paint",
    "mps_q18_4": "Hazardous chemicals",
    "mps_q18_5": "Junk vehicles",
    "mps_q18_6": "Mold",
    "mps_q18_7": "Pests / Wood boring insects",
    "mps_q18_8": "Radon",
    "mps_q18_9": "Underground tanks",
    "mps_q18_10": "If other, specify",
    "mps_q19": "Is radon mitigation system present?",
    "mps_q19_1": "Chain of custody",
    "mps_q19_2": "Last inspection",
    "hazards": "Hazards",
    "private": "Private",
    "public": "Public",
    "estimate_of_feasibility": "Estimate of feasibility",
    "items_and_details": "Items and details",
    "n_items_added": "{{n}} items added",
    "additional_certifications": "Additional certifications",
    "certification": "Certification",
    "certifications": {
      "wood_boring_insects": "Wood boring insects",
      "private_septic": "Private septic",
      "private_well": "Private well",
      "radon_gas": "Radon gas",
      "lead_paint": "Lead paint",
      "plumbing": "Plumbing",
      "heating": "Heating",
      "electrical": "Electrical",
      "underground_storage_tank": "Underground storage tank",
      "structural_engineer": "Structural engineer",
      "other": "Other"
    },
    "months_to_completion": "Months to completion",
    "months_uninhabitable_during_construction": "Months uninhabitable during construction",
    "n_months_one": "{{count}} month",
    "n_months_other": "{{count}} months",
    "construction_occupancy": {
      "label": "Construction occupancy",
      "new_unoccupied": "New construction – unoccupied",
      "new_occupied": "New construction – occupied",
      "existing_occupied": "Existing construction – occupied",
      "under_construction": "Under construction",
      "proposed_construction": "Proposed construction"
    },
    "locations": {
      "1st_floor": "1st floor",
      "2nd_floor": "2nd floor",
      "3rd_floor": "3rd floor",
      "1st_2nd_floor": "1st & 2nd floor",
      "1st_floor_bath": "1st floor bath",
      "2nd_floor_bath": "2nd floor bath",
      "3rd_floor_bath": "3rd floor bath",
      "1st_unit": "1st unit",
      "2nd_unit": "2nd unit",
      "3rd_unit": "3rd unit",
      "4th_unit": "4th unit",
      "1st_2nd_unit": "1st & 2nd unit",
      "1st_2nd_3rd_unit": "1st, 2nd, 3rd unit",
      "1st_2nd_3rd_4th_unit": "1st, 2nd, 3rd, 4th unit",
      "ac_unit": "A/c unit",
      "addition": "Addition",
      "areas_of_carpet": "Areas of carpet",
      "areas_of_damage": "Areas of damage",
      "areas_of_peeling_paint": "Areas of peeling paint",
      "areas_of_repair_peeling_paint": "Areas of repair & peeling paint",
      "areas_of_wallpaper": "Areas of wallpaper",
      "areas_where_missing": "Areas where missing",
      "attic": "Attic",
      "back_of_house": "Back of house",
      "back_porch": "Back porch",
      "backyard": "Backyard",
      "balcony": "Balcony",
      "barn": "Barn",
      "basement": "Basement",
      "basement_steps": "Basement steps",
      "basement_exterior": "Basement/exterior",
      "bathroom": "Bathroom",
      "bedroom": "Bedroom",
      "breezeway": "Breezeway",
      "common_area": "Common area",
      "ceilings": "Ceilings",
      "crawl_space": "Crawl space",
      "chimney": "Chimney",
      "closet": "Closet",
      "deck": "Deck",
      "designated_areas": "Designated areas",
      "dinning_room": "Dinning room",
      "dormer": "Dormer",
      "driveway": "Driveway",
      "entire_house": "Entire house",
      "entire_yard": "Entire yard",
      "entrance": "Entrance",
      "exterior": "Exterior",
      "exterior_door": "Exterior door",
      "electric": "Electric",
      "exterior_electric": "Exterior electric",
      "exterior_wall": "Exterior wall",
      "family_room": "Family room",
      "fence": "Fence",
      "fireplace": "Fireplace",
      "foundation": "Foundation",
      "floors": "Floors",
      "front_of_house": "Front of house",
      "front_porch": "Front porch",
      "front_steps": "Front steps",
      "front_yard": "Front yard",
      "garage": "Garage",
      "garage_door": "Garage door",
      "garage_house": "Garage/house",
      "gazebo": "Gazebo",
      "general": "General",
      "great_room": "Great room",
      "hvac": "Hvac",
      "interior": "Interior",
      "kitchen": "Kitchen",
      "kitchen_dinning_room": "Kitchen/dinning room",
      "kitchen_living_room": "Kitchen/living room",
      "kitchen_baths": "Kitchen & baths",
      "landscape": "Landscape",
      "laundry_room": "Laundry room",
      "laundry_utility_room": "Laundry/utility room",
      "living_room": "Living room",
      "outbuilding": "Outbuilding",
      "outbuilding_1": "Outbuilding #1",
      "outbuilding_2": "Outbuilding #2",
      "parking_area": "Parking area",
      "patio": "Patio",
      "perimeter_of_house": "Perimeter of house",
      "pool": "Pool",
      "roof": "Roof",
      "septic_system": "Septic system",
      "side_of_house": "Side of house",
      "shed": "Shed",
      "sidewalk": "Sidewalk",
      "siding": "Siding",
      "stairs_ext": "Stairs-ext",
      "stairs_int": "Stairs-int",
      "stairwell": "Stairwell",
      "steps": "Steps",
      "sunroom": "Sunroom",
      "trim": "Trim",
      "utility_room": "Utility room",
      "various_areas": "Various areas",
      "walkway": "Walkway",
      "window_wells": "Window wells",
      "windows": "Windows"
    },
    "level": "Level",
    "levels": {
      "mandatory": "Mandatory",
      "recommended": "Recommended",
      "desired": "Desired"
    },
    "item": "Item",
    "category": "Category",
    "photos": "Photos",
    "materials": "Materials",
    "labor": "Labor",
    "project_management_fee": "Project management fee",
    "repair_item_total": "Repair item total",
    "itemDetails": "Item details",
    "quantity": "Quantity",
    "unit": "Unit",
    "units": {
      "each": "Each",
      "linear_foot": "Linear foot",
      "lump_sum": "Lump sum",
      "square_foot": "Square foot",
      "square": "Square",
      "square_yard": "Square yard"
    },
    "details": "Details",
    "cost": "Cost",
    "costs": "Costs",
    "contractor_cost": "Contractor cost",
    "major_items": "Major items",
    "make_and_model": "Make and model",
    "drawings": "Drawings",
    "required_from_contractor": "Required from contractor",
    "structural": "Structural",
    "civil": "Civil",
    "landscaping": "Landscaping",
    "soil": "Soil",
    "riparian": "Riparian",
    "permits_label": "Permits",
    "repair_items": "Repair items",
    "repair_item": "Repair item",
    "costs_provided": "Costs provided",
    "signing_status": "Signing status",
    "approval_status": "Approval status",
    "approved": "Approved",
    "not_approved": "Not approved",
    "signed": "Signed",
    "not_signed": "Not signed",
    "n_years_one": "{{count}} year",
    "n_years_other": "{{count}} years",
    "loan_type": {
      "label": "Loan type",
      "hud_fha_limited": "HUD/FHA Limited",
      "hud_fha_230k": "HUD/FHA 203(k)",
      "fannie_mae_homestyle": "Fannie Mae Homestyle",
      "freddie_mac_choice": "Freddie Mac Choice",
      "other": "Other"
    },
    "view_all": "View all",
    "recent_activity": "Recent activity",
    "no_documents": "No documents yet",
    "no_invoices": "No invoices yet",
    "no_upcoming_meetings": "You have no upcoming meetings",
    "no_recent_activity": "No recent activity",
    "action_required": "Action required",
    "pay_invoice_message": "Please pay the invoice to continue",
    "assign_inspector": "Invite an inspector to the project",
    "assign_contractor": "Invite a contractor to the project",
    "assign_client": "Invite a client to the project",
    "assign_loan_officer": "Invite a loan officer to the project",
    "accept_invitation_to_view_documents": "You need to accept the project invitation to view documents",
    "accept_invitation_to_view_meetings": "You need to accept the project invitation to view meetings",
    "accept_invitation_to_view_activity": "You need to accept the project invitation to view activity",
    "tasks": {
      "intake": {
        "assign_client": {
          "admin": "Invite a client to the project",
          "action": "Invite client",
          "others": "Admin needs to invite a client to the project"
        },
        "admin_approve": {
          "admin": "Accept invitation to continue with this project",
          "others": "Admin needs to accept the project"
        }
      },
      "payment": {
        "rca": {
          "client": "Review and accept the Renovation Consultant Agreement (RCA)",
          "others": "Client needs to accept the Renovation Consultant Agreement (RCA)",
          "action": "Review RCA",
          "payTooltip": "You must review and accept the Renovation Consultant Agreement (RCA) before you can pay this invoice"
        },
        "pay_invoice": {
          "client": "Pay the invoice to continue",
          "others": "Client needs to pay the invoice",
          "action": "Pay the invoice"
        }
      },
      "staffing": {
        "inspector_invited": {
          "admin": "Invite an inspector to the project",
          "action": "Invite inspector",
          "others": "Admin needs to invite an inspector to the project"
        },
        "inspector_assigned": {
          "inspector": "Accept invitation to continue with this project",
          "others": "Inspector needs to accept the project invitation"
        },
        "work_order_approved": {
          "admin": "Review and approve the work order",
          "action": "Review work order",
          "others": "Admin needs to approve the work order"
        },
        "work_order_accepted": {
          "inspector": "Review and accept the work order",
          "action": "Review work order",
          "others": "Inspector needs to review and accept the work order"
        },
        "loan_officer_assigned": {
          "others": "Admin needs to invite a loan officer to the project"
        }
      },
      "scheduling": {
        "schedule_inspection": {
          "inspector": "Schedule an inspection meeting",
          "action": "Schedule meeting",
          "others": "Inspector needs to schedule an inspection meeting"
        }
      },
      "inspection": {
        "complete_inspection": {
          "others": "Inspection scheduled. Waiting for inspection to be completed."
        },
        "inspection_in_review": {
          "inspector": "Complete and submit the Minimum Property Standards (MPS) form",
          "action": "Open MPS form",
          "others": "Waiting for inspector to submit the Minimum Property Standards (MPS) form"
        },
        "inspection_reviewed": {
          "admin": "Review and submit the Minimum Property Standards (MPS) form",
          "action": "Open MPS form",
          "others": "Waiting for admin to review the Minimum Property Standards (MPS) form"
        }
      },
      "work_write_up": {
        "contractor_invited": {
          "others": "Admin needs to invite a contractor to the project"
        },
        "contractor_assigned": {
          "others": "Contractor needs to accept the project invitation"
        },
        "sor_started": {
          "admin": "Complete the Specification of Repairs (SOR) form and request costs",
          "action": "Open SOR form",
          "contractor": "Admin needs to request costs for the Specification of Repairs (SOR) form",
          "others": "Waiting for work write-up completion"
        },
        "sor_cost_provided": {
          "admin": "Contractor needs to provide costs to the Specification of Repairs (SOR) form",
          "action": "Open SOR form",
          "contractor": "Provide costs to the Specification of Repairs (SOR) form",
          "others": "Waiting for work write-up completion"
        },
        "sor_cost_reviewed": {
          "contractor": "Admin needs to review and approve costs for the Specification of Repairs (SOR) form",
          "action": "Open SOR form",
          "admin": "Review and approve costs for the Specification of Repairs (SOR) form",
          "others": "Waiting for work write-up completion"
        },
        "sor_reviewed": {
          "admin_and_contractor": "Loan officer needs to complete the Specification of Repairs (SOR) form",
          "action": "Open SOR form",
          "loan_officer": "Complete the Specification of Repairs (SOR) form",
          "others": "Waiting for work write-up completion"
        },
        "sor_completed": {
          "admin": "Complete the Specification of Repairs (SOR) form",
          "action": "Open SOR form",
          "others": "Waiting for SOR form to be completed to generate feasibility report"
        },
        "full_report_signed": {
          "user_to_sign": "You need to sign the full report.",
          "waiting_for_others": "You have completed your signing. Waiting for others.",
          "action": "Open full report",
          "everyone_signed": "All signatures collected. Full Report is complete."
        }
      }
    },
    "pdf_preview_unavailable": "PDF preview unavailable for this file",
    "convert_to_full_report": "Convert to full report",
    "contingency_reserve_percentage": "Contingency reserve percentage",
    "project_management_fee_rate": "Project management fee rate",
    "interest_income_application": {
      "label": "Interest income application",
      "direct_payment": "Direct payment",
      "principal_reduction": "Principal reduction",
      "escrow_application": "Escrow application"
    },
    "payout_ready": "You are fully onboarded and eligible to receive payments.",
    "payout_not_onboarded": "Onboarding incomplete. Please complete Stripe onboarding to receive payments.",
    "payout_not_connected": "No Stripe account found. Please create a payment account.",
    "payout_disabled": "Your Stripe account exists, but payouts are disabled. Please log in to Stripe and resolve the issue.",
    "payout_create_account": "Create account",
    "payout_complete_onboarding": "Complete onboarding",
    "payout_login": "Login",
    "timeline": "Timeline",
    "new_step_name": "New step name",
    "insert_after_step": "Insert after step",
    "manual_step": "Manual step",
    "sor": {
      "overview": {
        "label": "Overview"
      },
      "workClassifications": {
        "label": "Work classification",
        "title": "Work classification",
        "isStructural": "Is the work structural in nature?",
        "leadBasedPaint": "Lead-based paint",
        "certificateCopyRequired": "Copy of certification required.",
        "certificateCopyNotRequired": "Copy of certification is not required.",
        "contractorIsLbpCertified": "Contractor is LBP Certified",
        "contractorWillEmployLbpPainter": "Contractor will employ a LBP-certified painter",
        "notRequired": "Not required",
        "uploadCertification": "Upload certification",
        "uploadCertificationDescription": "The file must be a PDF, JPG, or DOCX (max. 5MB)",
        "houseHabitableQuestion": "Will the house be habitable within 15 days during the rehab period?"
      },
      "projectCompliance": {
        "label": "Project compliance",
        "title": "Project compliance",
        "permitDetailsLabel": "Permit details",
        "arePermitsRequired": "Are permits required?",
        "permitsAreNotRequired": "Permits are not required",
        "permitMunicipalityQuestion": "Which municipality does the permit need to be obtained from?",
        "permitMunicipalityPlaceholder": "Village/town/county",
        "permits": {
          "electrical": "Electrical",
          "hvac": "HVAC",
          "plumbing": "Plumbing",
          "gas": "Gas",
          "generalStructure": "General (structure)",
          "foundation": "Foundation",
          "framing": "Framing",
          "demolition": "Demolition",
          "roof": "Roof",
          "pest": "Pest",
          "radon": "Radon",
          "other": "Other"
        },
        "permitCosts": "Permit costs",
        "permitCost": "Permit cost",
        "requireCertificationAfterWork": "Require certification after work",
        "permitRequested": "Permit requested",
        "selectRequiredPermits": "Select required permits",
        "escrowLabel": "Escrow",
        "fhaProceedsInstruction": "FHA 203(k) proceeds will be placed in escrow. After Final Release, apply interest to:",
        "applyToSelf": "Pay directly to me/us",
        "applyToMortgage": "Apply to mortgage principal",
        "applyToEscrow": "Apply to escrow",
        "complianceLabel": "Compliance",
        "acknowledgement": "* I acknowledge this work complies with building codes and standards"
      },
      "itemsAndDetails": {
        "label": "Items and details",
        "title": "Items and details",
        "levels": {
          "label": "Level",
          "mandatory": "Mandatory",
          "recommended": "Recommended",
          "desired": "Desired"
        },
        "costs": {
          "label": "Costs",
          "materials": "Materials",
          "quantity": "Quantity",
          "units": "Units",
          "cost": "Cost",
          "totalMaterialCost": "Total material cost",
          "totalLaborCost": "Total labor cost",
          "total": "Total",
          "labor": "Labor",
          "projectManagementFee": "Project management fee"
        },
        "majorItems": "Major items",
        "makeAndModel": "Make and model",
        "imageOrBrochure": "Image or brochure",
        "cost": "Cost",
        "imageBrochureSpec": "Drawing, spec sheets, letters, image, or certification",
        "drawings": "Drawings, spec sheets, letters, and certifications",
        "requestDrawings": "Do you want to request drawings from your contractor?",
        "engineeringSupportType": {
          "label": "Request engineering support",
          "cost": "Architectural / engineering costs",
          "attachments": "Attachments",
          "structural": "Structural",
          "civil": "Civil",
          "landscaping": "Landscaping",
          "soil": "Soil",
          "riparian": "Riparian"
        }
      },
      "scheduleMeeting": {
        "label": "Schedule a meeting"
      },
      "summary": {
        "label": "Summary",
        "title": "Summary"
      }
    },
    "not_applicable": "Not applicable",
    "password": "Password",
    "old_password": "Old password",
    "new_password": "New password",
    "repeat_password": "Repeat password",
    "file_upload_formats": "Accepted formats: {{formats}}.",
    "file_upload_size": "Maximum size {size}.",
    "companyChangeUnderReview": "Your company change request is under review.",
    "userRequestedToChangeCompany": "User requested to change company",
    "changeCompany": {
      "label": "Change company",
      "requestCompanyChange": "Request company change",
      "description": "Our team will review your request and contact you soon.",
      "requestHasBeenSent": "Company change request has been sent",
      "companyHasBeenChanged": "Company has been changed",
      "requestHasBeenRejected": "Request has been rejected",
      "requestHasBeenCancelled": "Request has been cancelled",
      "companyNotListed": "My company is not listed",
      "companyName": "Company name",
      "companyNamePlaceholder": "Enter your company name",
      "companyChangeRequestIsPending": "A company change request is pending",
      "youHaveSubmittedACompanyChangeRequest": "You have submitted a company change request",
      "yourRequestHasBeenRejected": "Your request has been rejected: {{reason}}",
      "reviewRequest": "Review request",
      "currentCompany": "Current company",
      "requestedCompany": "Requested company",
      "cancelRequest": "Cancel request",
      "adminProjectAccept": {
        "alert": "Requested company does not exist in the system. You need to add a new company to proceed.",
        "acceptedToast": "You have accepted the project"
      },
      "youNeedToAddNewCompanyToProceed": "Add a new company to proceed."
    },
    "response": "Response",
    "myProjects": "My projects",
    "allProjects": "All projects",
    "projectNeedsAdminAcceptance": "Project needs admin acceptance",
    "projectIsArchived": "This project is archived. You can view its details, but no further actions are available.",
    "projectAcceptedToast": "You have accepted the project",
    "privacyConsent": {
      "title": "Privacy consent",
      "agreeAndContinue": "Agree and continue",
      "consentText": "I have read and agree to the Privacy Policy."
    },
    "thisWeek": "This week",
    "thisMonth": "This month",
    "lotSizeAcres": "Lot size, acres",
    "createNewPassword": "Create new password",
    "emailNotRegistered": "We could not find an account associated with this email address. Please check your spelling and try again.",
    "enterEmailForResetLink": "We are sending you a password reset link. Please check your inbox and follow the link to reset your password.",
    "forgotPassword": "Forgot password",
    "forgotPasswordEmailSent": "We've sent you a link to reset your password.",
    "haveAccountMessage": "Already have an account?",
    "passwordRuleMinLength": "Minimum 8 characters",
    "passwordRuleLowercase": "At least one lowercase letter",
    "passwordRuleUppercase": "At least one uppercase letter",
    "passwordRuleNumber": "At least one number",
    "passwordRuleSymbol": "At least one symbol",
    "createPassword": "Create password"
  },
  "status": {
    "draft": "Draft",
    "cost_providing": "Costs Providing",
    "cost_reviewing": "Costs Reviewing",
    "in_review": "In Review",
    "in_signing": "In Signing",
    "finished": "Finished",
    "new": "New",
    "updated": "Updated",
    "active": "Active",
    "completed": "Completed",
    "archived": "Archived",
    "pending": "Pending",
    "in_progress": "In progress",
    "in-progress": "In progress",
    "invalid": "Invalid"
  },
  "placeholder": {
    "search": "Search...",
    "member_picture": "Member picture",
    "choose_municipality": "Choose municipality",
    "enter_cost": "Enter cost",
    "enterCompanyName": "Enter company name",
    "comment": "Add a comment",
    "selectTankType": "Select tank type",
    "otherDefects": "Describe the defective condition",
    "otherHazards": "Describe the hazard",
    "writeYourResponse": "Write your response",
    "writeANote": "Write a note",
    "propertyAccess": "Access instructions (e.g., lockbox code, gate code)",
    "projectStage": "Select project stage",
    "enterCost": "Enter cost",
    "selectLoanType": "Select loan type",
    "enterDwellingUnits": "Enter number of dwelling units",
    "selectStatus": "Select status",
    "selectPeriod": "Select period",
    "selectCompany": "Select company",
    "selectProperty": "Select property",
    "selectProjectType": "Select project type",
    "selectConstructionOccupancy": "Select construction occupancy",
    "enterPhoneNumber": "Enter phone number",
    "enterFhaCaseNumber": "Enter FHA case number",
    "selectAdmin": "Select admin",
    "selectContractor": "Select contractor",
    "selectInspector": "Select inspector",
    "selectClient": "Select client",
    "selectLoanOfficer": "Select loan officer",
    "selectLoanProcessor": "Select loan processor",
    "selectProjectManager": "Select project manager",
    "searchAddress": "Search address...",
    "enterEmail": "Enter email",
    "enterFullName": "Enter full name",
    "enterPassword": "Enter password",
    "writeAMessage": "Write a message"
  },
  "banner": {
    "empty_document_title": "No document",
    "emptyNotifications": {
      "noItems": {
        "title": "No notifications"
      }
    },
    "emptyProjects": {
      "editorNoItems": {
        "title": "No projects available",
        "text": "Add a project to make it appear here"
      },
      "viewerNoItems": {
        "title": "No projects available",
        "text": "Projects will be displayed here once you're invited to them"
      },
      "filtersApplied": {
        "title": "No projects match your filters",
        "text": "Adjust or clear filters to see available projects"
      }
    },
    "emptyProperties": {
      "editorNoItems": {
        "title": "No properties available",
        "text": "Add a property to make it appear here."
      },
      "viewerNoItems": {
        "title": "No properties available",
        "text": "Properties will be displayed here once they are added."
      },
      "filtersApplied": {
        "title": "No properties match your filters",
        "text": "Adjust or clear filters to see available properties."
      }
    },
    "emptyCompanies": {
      "editorNoItems": {
        "title": "No companies available",
        "text": "Add a company to make it appear here."
      },
      "viewerNoItems": {
        "title": "No companies available",
        "text": "Companies will be displayed here once they are added."
      },
      "filtersApplied": {
        "title": "No companies match your filters",
        "text": "Adjust or clear filters to see available companies."
      }
    },
    "emptyUsers": {
      "editorNoItems": {
        "title": "No users available",
        "text": "Invite a user to make it appear here."
      },
      "pendingInvitation": {
        "title": "Invitation pending",
        "text": "This user hasn't accepted their invitation yet."
      },
      "viewerNoItems": {
        "title": "No users available",
        "text": "Users will be displayed here once they are invited and onboarded."
      },
      "filtersApplied": {
        "title": "No users match your filters",
        "text": "Adjust or clear filters to see available users."
      }
    },
    "emptyProjectMembers": {
      "filtersApplied": {
        "title": "No users match your filters",
        "text": "Adjust or clear filters to see available users."
      }
    },
    "emptyProjectFiles": {
      "noItems": {
        "title": "No files available",
        "text": "Add a file to make it appear here."
      },
      "filtersApplied": {
        "title": "No files match your filters",
        "text": "Adjust or clear filters to see available files."
      }
    },
    "emptyProjectForms": {
      "noItems": {
        "title": "No forms available",
        "text": "Forms will appear here as the project progresses."
      }
    },
    "emptyProjectInvoices": {
      "noItems": {
        "title": "No invoices available",
        "text": "Invoices will appear here as the project progresses."
      }
    },
    "emptyProjectMeetings": {
      "noItems": {
        "title": "No meetings available",
        "text": "Add a meeting to make it appear here."
      },
      "filtersApplied": {
        "title": "No meetings match your filters",
        "text": "Adjust or clear filters to see available meetings."
      }
    },
    "emptyProjectActivityLog": {
      "noItems": {
        "title": "No activity yet",
        "text": "Activities will appear here as the project progresses."
      }
    },
    "emptyTenants": {
      "noItems": {
        "title": "No tenants available",
        "text": "Add a tenant to make them appear here."
      },
      "filtersApplied": {
        "title": "No tenants match your filters",
        "text": "Adjust or clear filters to see available tenants."
      }
    }
  },
  "validation": {
    "required": "This field is required",
    "phone_invalid": "This field is invalid",
    "loan_type_required": "Select a loan type.",
    "loan_id_required": "Enter a loan ID.",
    "pattern_fha_case_number": "FHA case number must be 10 digits.",
    "pattern_du_casefile": "Enter a DU Casefile ID (6–20 letters/numbers, no spaces).",
    "pattern_lpa_key": "Enter an LPA Key Number (A1234567 or AA123456).",
    "lump_sum_quantity": "Quantity must be 1 for Lump Sum",
    "engineering_support_type": "Select at least one engineering support type",
    "no_repair_items_selected": "Select at least one repair item",
    "no_permit_costs_provided": "Provide a cost for at least one permit",
    "repair_items_incomplete": "Complete all required fields for repair items",
    "tin_already_used": "This TIN is already registered in the system.",
    "ssn_already_used": "This SSN/EIN is already registered in the system.",
    "pattern_tin_number": "TIN must be 9 digits.",
    "pattern_ssn_number": "SSN/EIN must be 9 digits.",
    "passwords_must_match": "Passwords must match",
    "password_length": "Password must be at least 8 characters",
    "url_invalid": "Please enter a valid URL",
    "email_invalid": "Please enter a valid email",
    "end_time_after_start": "Must be after start time",
    "units_at_completion_exceeds": "Cannot exceed number of units",
    "invalidEmailOrPassword": "Invalid email or password",
    "passwordTooWeak": "Password is too weak",
    "passwordTooLong": "Password must be shorter than 256 characters",
    "passwordRecentlyUsed": "Password must not be the same as one recently used",
    "passwordBanned": "Password contains a word, phrase, or pattern that is banned",
    "passwordIsInvalid": "Password is invalid",
    "userAlreadyExists": "An account with these details already exists. Sign in or use a different email to sign up.",
    "invalidWholeNumber": "Enter a whole number",
    "selectAddress": "Select an address from the list"
  },
  "toast": {
    "invitation_email_sent": "The invitation email has been sent to {{to}}",
    "invitation_withdrawn": "The invitation has been withdrawn",
    "contractor_deleted": "Contractor {{what}} has been suspended",
    "loan_officer_deleted": "Loan officer {{what}} has been suspended",
    "loan_processor_deleted": "Loan processor {{what}} has been suspended",
    "user_removed_from_project": "{{what}} has been removed from the project",
    "admin_deleted": "Admin {{what}} has been suspended",
    "project_manager_deleted": "Project manager {{what}} has been suspended",
    "inspector_deleted": "Inspector {{what}} has been suspended",
    "delete_client": "Client {{what}} has been suspended",
    "project_created": "Project has been created",
    "file_deleted": "File has been deleted",
    "file_uploaded": "File has been uploaded",
    "create_meeting": "Meeting has been created",
    "update_meeting": "Meeting has been updated",
    "cancel_meeting": "Meeting has been canceled",
    "add_member": "Member has been added",
    "add_company": "Company has been added",
    "update_company": "Company has been updated",
    "add_tenant": "Tenant has been added",
    "add_tenant_admin": "Tenant admin has been added",
    "property_added": "Property {{what}} has been added",
    "property_updated": "Property {{what}} has been updated",
    "property_deleted": "Property {{what}} has been deleted",
    "projectDeleted": "Project has been deleted",
    "form_save_success": "Form has been saved",
    "request_costs_success": "Costs request sent to contractor",
    "submit_costs_success": "Costs submitted for review",
    "approve_costs_success": "Costs approved",
    "approve_success": "Form approved",
    "sign_success": "Form signed",
    "complete_success": "Form completed",
    "repair_item_deleted": "{{what}} has been deleted",
    "pdf_preview_error": "Failed to load PDF preview",
    "download_error": "Could not download document",
    "password_updated_success": "Password updated successfully",
    "addressUpdated": "Address has been updated",
    "taxInformationUpdated": "Tax information has been updated",
    "hudDetailsUpdated": "HUD details have been updated",
    "serviceAreaUpdated": "Service area has been updated",
    "licenseDetailsUpdated": "License details have been updated",
    "experienceUpdated": "Experience has been updated",
    "passwordResetErrorMessage": "The link may have expired. Please request a new one.",
    "passwordResetErrorTitle": "Password reset failed",
    "passwordResetSuccessTitle": "Password has been reset successfully"
  },
  "confirm": {
    "suspend_title": "Confirm suspension",
    "delete_title": "Confirm deletion",
    "action_title": "Confirm action",
    "deleteAllNotificationsSubtitle": "All notifications will be removed permanently.",
    "request_costs_title": "Confirm that you want to request costs from the contractor",
    "delete_contractor_subtitle": "Deleting contractor will remove them permanently.",
    "delete_loan_officer_subtitle": "Deleting loan officer will remove them permanently.",
    "delete_loan_processor_subtitle": "Deleting loan processor will remove them permanently.",
    "delete_admin_subtitle": "Deleting admin will remove them permanently.",
    "delete_inspector_subtitle": "Deleting inspector will remove them permanently.",
    "delete_client_subtitle": "Deleting client will remove them permanently.",
    "delete_project_manager_subtitle": "Deleting project manager will remove them permanently.",
    "delete_file_subtitle": "Deleting file will remove it permanently.",
    "delete_tenant_subtitle": "Deleting tenant will remove it permanently.",
    "delete_company_subtitle": "Deleting company will remove it permanently.",
    "delete_property_subtitle": "Deleting property will remove it permanently.",
    "archive_project_subtitle": "Once archived, this project will stop all activity and can no longer be updated.",
    "cancel_meeting_subtitle": "Are you sure you want to cancel this meeting?",
    "mark_company_as_wrong": "Our team will review your request and contact you soon.",
    "reject_project_title": "Are you sure you want to reject this project invitation?",
    "sign_title": "Signature confirmation",
    "sign_text": "By clicking Sign, you are signing this document electronically. You agree your electronic signature is the legal equivalent of your manual signature on this document. You further agree that no certification authority or other third-party verification is necessary to validate your electronic signature, and that the lack of such certification or third-party verification will not in any way affect the enforceability of your signature or resulting contract.",
    "removeFromProject": "Are you sure you want to remove this user from the project?",
    "leaveProject": "Are you sure you want to leave this project?"
  },
  "tenant_selection": {
    "title": "Select a workspace",
    "subtitle": "You have access to multiple workspaces. Please select one to continue.",
    "no_tenants_title": "No workspace access",
    "no_tenants_subtitle": "You don't have access to any workspace yet.",
    "no_tenants_message": "Please contact your administrator to get access to a workspace, or wait for an invitation."
  },
  "error": {
    "file_too_large_title": "File is too large",
    "file_too_large_message": "The file must be {{sizeInMb}}MB or smaller.",
    "profile_picture_load_failed": "Unable to load profile picture"
  },
  "constraint": {
    "role_already_assigned": "This project already has a member with this role"
  },
  "legal": {
    "cookie_banner": {
      "title": "We use cookies to enhance your experience",
      "text": "We use cookies and similar technologies to improve functionality, analyze site usage, and provide personalized content. By clicking \"Accept All\", you consent to our use of cookies. You can find out more about our use of cookies at our <1>Cookies Notice</1>, and about our data privacy measures at our <3>Privacy Policy</3>.",
      "manage_cookies": "Manage cookies",
      "reject_all": "Reject all",
      "accept_all": "Accept all"
    },
    "cookie_notice": {
      "title": "Cookie notice",
      "essential_cookies": "Essential Cookies",
      "essential_cookies_description": "These cookies are essential for us to provide you with access to and use of the Platform, and for you to move around the Platform and receive our Services.",
      "optional_cookies": "Optional Cookies",
      "optional_cookies_description": "If you don’t allow these cookies, some features of our Services may not work, and your experience on our Platform may not be as smooth.",
      "essential_cookies_group_title": "Essential cookies cannot be disabled.",
      "analytical_cookies_group_title": "Analytical cookies",
      "analytical_cookies_group_text": "These cookies track Platform performance, usage patterns, and any issues Users may encounter. We use this data to ensure the Platform run smoothly, and to improve your experience on our Platform.",
      "cookie": "Cookie",
      "purpose": "Purpose",
      "duration": "Duration",
      "alwaysActive": "Always active"
    },
    "privacy_policy": {
      "privacy_policy": "Privacy policy",
      "effective_date": "Effective Date: January 1, 2025",
      "last_updated": "Last Updated: January 1, 2025",
      "table_of_contents": "Table of Contents",
      "toc1_title": "1. Information We Collect",
      "toc2_title": "2. How We Use Information",
      "toc3_title": "3. Information Sharing",
      "toc4_title": "4. Data Security",
      "toc5_title": "5. Your Rights",
      "toc6_title": "6. Data Retention",
      "toc7_title": "7. International Transfers",
      "toc8_title": "8. Children's Privacy",
      "toc9_title": "9. Changes to This Policy",
      "toc10_title": "10. Contact Us",
      "description1": "QuickConnex LLC (\"QuickConnex,\" \"we,\" \"us,\" or \"our\") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our renovation loan management platform and related services (the \"Services\").",
      "description2": "By using our Services, you agree to the collection and use of information in accordance with this Privacy Policy. If you do not agree with the terms of this policy, please do not access the Services.",
      "toc1_subtitle": "Personal Information:",
      "toc1_item1": "Name, email address, phone number, and mailing address",
      "toc1_item2": "Job title and company information",
      "toc1_item3": "Financial information (for borrowers and lenders)",
      "toc1_item4": "Government-issued identification numbers (where required for compliance)",
      "toc1_item5": "Property information and renovation project details",
      "toc1_auto_subtitle": "Automatically Collected Information:",
      "toc1_auto_item1": "IP address and device information",
      "toc1_auto_item2": "Browser type and operating system",
      "toc1_auto_item3": "Usage data and analytics",
      "toc1_auto_item4": "Cookies and similar tracking technologies",
      "toc1_auto_item5": "Log files and clickstream data",
      "toc1_third_subtitle": "Information from Third Parties:",
      "toc1_third_item1": "Credit reports (with your authorization)",
      "toc1_third_item2": "Property valuation data",
      "toc1_third_item3": "Background check information (for certain user types)",
      "toc1_third_item4": "Information from integrated third-party services",
      "toc2_description": "We use the collected information for:",
      "toc2_item1": "Providing and maintaining our Services",
      "toc2_item2": "Processing loan applications and managing renovation projects",
      "toc2_item3": "Facilitating communication between users",
      "toc2_item4": "Verifying identity and preventing fraud",
      "toc2_item5": "Complying with legal and regulatory requirements",
      "toc2_item6": "Improving our Services and developing new features",
      "toc2_item7": "Sending administrative and marketing communications",
      "toc2_item8": "Analyzing usage patterns and trends",
      "toc2_item9": "Protecting the rights and safety of users and QuickConnex",
      "toc3_description": "We may share your information with:",
      "toc3_item1": "Other Users: As necessary to facilitate loan transactions and project management",
      "toc3_item2": "Service Providers: Third parties who perform services on our behalf",
      "toc3_item3": "Business Partners: Integrated services and platform partners",
      "toc3_item4": "Legal Requirements: When required by law or to protect rights and safety",
      "toc3_item5": "Business Transfers: In connection with mergers, acquisitions, or asset sales",
      "toc3_item6": "Consent: With your explicit consent for other purposes",
      "toc3_note": "We do not sell, rent, or trade your personal information to third parties for their marketing purposes.",
      "toc4_description": "We implement appropriate technical and organizational measures to protect your information, including:",
      "toc4_item1": "Encryption of data in transit and at rest",
      "toc4_item2": "Regular security assessments and audits",
      "toc4_item3": "Access controls and authentication mechanisms",
      "toc4_item4": "Employee training on data protection",
      "toc4_item5": "Incident response procedures",
      "toc4_item6": "SOC 2 Type II compliance",
      "toc4_note": "However, no method of transmission over the Internet or electronic storage is 100% secure. While we strive to protect your information, we cannot guarantee absolute security.",
      "toc5_description": "Depending on your location, you may have the following rights:",
      "toc5_item1": "Access: Request a copy of your personal information",
      "toc5_item2": "Correction: Request correction of inaccurate information",
      "toc5_item3": "Deletion: Request deletion of your information (subject to legal requirements)",
      "toc5_item4": "Portability: Receive your information in a structured format",
      "toc5_item5": "Objection: Object to certain processing activities",
      "toc5_item6": "Restriction: Request restriction of processing",
      "toc5_item7": "Withdrawal: Withdraw consent where processing is based on consent",
      "toc5_contact": "To exercise these rights, please contact us at privacy@quickconnex.tech.",
      "toc6_description": "We retain personal information for as long as necessary to:",
      "toc6_item1": "Provide our Services",
      "toc6_item2": "Comply with legal obligations",
      "toc6_item3": "Resolve disputes",
      "toc6_item4": "Enforce our agreements",
      "toc6_note": "Retention periods vary based on the type of information and legal requirements. Financial records are typically retained for 7 years after account closure.",
      "toc7_description": "Your information may be transferred to and processed in countries other than your country of residence. These countries may have different data protection laws. We ensure appropriate safeguards are in place for such transfers, including:",
      "toc7_item1": "Standard contractual clauses",
      "toc7_item2": "Data processing agreements",
      "toc7_item3": "Appropriate technical and organizational measures",
      "toc8_description": "Our Services are not intended for individuals under 18 years of age. We do not knowingly collect personal information from children under 18. If we learn we have collected information from a child under 18, we will delete that information promptly.",
      "toc9_description": "We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the \"Last Updated\" date. For material changes, we will provide additional notice via email or through the Services.",
      "toc10_company_name": "QuickConnex Software LLC",
      "toc10_address_line1": "1930 20th Street",
      "toc10_address_line2": "Cuyahoga Falls, OH 44223",
      "toc10_country": "United States",
      "toc10_email": "Email: privacy@quickconnex.tech",
      "toc10_phone": "Phone: (330) 555-0100"
    }
  }
}
